// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbsRow":"cw","breadcrumbForward":"dw","breadcrumbBack":"ew","selected":"fw"};